import { z } from "zod";
import { RequestFieldEffectDtoSchema } from "./RequestFieldEffectDto";

export const RequestFieldsRelationOutputSchema = z.object({
    fields: z.array(RequestFieldEffectDtoSchema).nullish(),
});

export type RequestFieldsRelationOutput = z.infer<typeof RequestFieldsRelationOutputSchema>;
